<template>
  <div class="container mt-3" id="platformAddForm" v-if="!mainLoaiding">
    <div class="mt-3">
      <h3 class="title mb-3">플랫폼 {{ type === FORM_TYPE.INSERT ? '생성' : '수정' }}</h3>
    </div>

    <div class="class-manage-card p-3">
      <h4 class="title mb-3">※플랫폼 정보관리</h4>
      <Form @submit="onSubmit" :initial-values="initialValues" v-slot="{ values }" ref="platfomrAddForm">
        <table class="info">
          <tbody>
            <tr>
              <td class="w-20per txt-center label p-2" id="companyLabel">Company <span class="required">*</span></td>
              <td class="w-75per p-3">
                <div class="w-35per d-inline-block">
                  <!-- 고객사명 -->
                  <Field
                    ref="companyNameRef"
                    v-model="initialValues.sugang.companyName"
                    id="companyName"
                    name="companyName"
                    label="고객사명"
                    type="text"
                    v-slot="{ field, errors }"
                    rules="required">
                    <b-form-input
                      disabled
                      v-model="initialValues.sugang.companyName"
                      v-bind="field"
                      id="companyName"
                      type="text"
                      placeholder="검색을 통해 고객사명을 선택해주세요."
                      :state="errors[0] ? false : null">
                    </b-form-input>
                    <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                  </Field>
                </div>
                <b-button variant="primary" class="ms-2 align-top" @click="funcIsCompanyModal">고객사 검색</b-button>
              </td>
            </tr>
            <tr>
              <td class="w-20per txt-center label p-2">페이지 url <span class="required">*</span></td>
              <td class="w-75per p-3">
                <!-- 페이지 url -->
                <div class="w-48per d-inline-block">
                  <Field v-model="initialValues.sugang.dupConfirmCode" id="dupConfirmCode" name="dupConfirmCode" v-slot="{ field }" label="페이지url중복">
                    <input v-model="initialValues.sugang.dupConfirmCode" type="text" hidden v-bind="field" />
                  </Field>
                  <Field
                    v-model="initialValues.sugang.code"
                    id="code"
                    ref="codeRef"
                    name="code"
                    label="페이지 url"
                    type="text"
                    rules="required|textSize:4,10|alpha_num|isDup:dupConfirmCode"
                    v-slot="{ field, errors }">
                    <b-form-input
                      v-model="initialValues.sugang.code"
                      v-bind="field"
                      id="code"
                      type="text"
                      placeholder="페이지 url을 입력해주세요."
                      @update:modelValue="changePageCode"
                      @keyup.enter="checkCode(initialValues.sugang.code)"
                      :state="errors[0] ? false : null">
                    </b-form-input>
                    <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                  </Field>
                </div>
                <b-button variant="primary" class="ms-2 align-top" @click="checkCode(initialValues.sugang.code)">중복확인</b-button>
                <div class="align-items-center ps-1 d-inline-block align-top mt-2">
                  <span> ※ 4자 이상, 10자 이하 영소문자, 숫자만 입력 가능합니다 </span>
                </div>

                <div class="d-flex mt-2">
                  <div class="d-flex align-items-center">
                    <span
                      >*수강신청 URL로 사용됩니다. Ex) {{ siteUrl }}/settings/<span class="bold">{{ initialValues.sugang.code }}</span>
                    </span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="w-20per txt-center label p-2">고객사 로고 <span class="required">*</span></td>
              <td class="w-75per p-3">
                <div class="d-flex align-items-center">
                  <div class="w-40per" v-show="!initialValues.sugang.companyLogoUrl">
                    <Field
                      v-model="initialValues.sugang.companyLogoUrl"
                      id="companyLogoUrl"
                      name="companyLogoUrl"
                      ref="companyLogoUrlRef"
                      label="고객사 로고"
                      rules="required"
                      type="text"
                      v-slot="{ field, errors }">
                      <input class="form-control" :class="{ 'is-invalid': errors[0] ? true : false }" ref="clientImageRef" type="file" name="clientImage" id="companyLogoUrl" />
                      <input id="companyLogoUrl" type="hidden" v-bind="field" />
                      <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                    </Field>
                  </div>

                  <div v-show="initialValues.sugang.companyLogoUrl && initialValues.sugang.companyLogoName" class="d-flex align-items-center">
                    <span class="hyperlink" @click="preView(initialValues.sugang.companyLogoUrl)">{{ initialValues.sugang.companyLogoName }}</span>
                  </div>

                  <b-button v-show="initialValues.sugang.companyLogoUrl && initialValues.sugang.companyLogoName" variant="danger" class="ms-2" @click="deleteImage">삭제하기</b-button>
                </div>
                <div class="d-flex flex-column mt-2">
                  <div class="d-flex align-items-center">
                    <span>※ jpg, png, jpeg 파일만 등록 가능</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <span>※ 로고는 최소 높이 <span class="bold">35px(픽셀) </span>에 맞춰서 적용됩니다.</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="w-20per txt-center label p-2">플랫폼명 <span class="required">*</span></td>
              <td class="w-75per p-3">
                <div class="w-50per d-inline-block">
                  <Field v-model="initialValues.sugang.platformName" id="platformName" name="platformName" label="플랫폼명" rules="required" v-slot="{ field, errors }">
                    <b-form-input
                      v-model="initialValues.sugang.platformName"
                      v-bind="field"
                      id="platformName"
                      type="text"
                      placeholder="플랫폼 타이틀을 입력해주세요"
                      :state="errors[0] ? false : null">
                    </b-form-input>
                    <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                  </Field>
                </div>
              </td>
            </tr>
            <tr>
              <td class="w-20per txt-center label p-2">신청 차수명 <span class="required">*</span></td>
              <td class="w-75per p-3">
                <div class="w-50per d-inline-block">
                  <Field v-model="initialValues.sugang.chasuName" id="chasuName" name="chasuName" label="신청 차수명" rules="required" v-slot="{ field, errors }">
                    <b-form-input
                      v-model="initialValues.sugang.chasuName"
                      id="chasuName"
                      v-bind="field"
                      type="text"
                      placeholder="신청 차수명을 입력해주세요"
                      :state="errors[0] ? false : null">
                    </b-form-input>
                    <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                  </Field>
                </div>
              </td>
            </tr>
            <tr>
              <td class="w-20per txt-center label p-2">수강 신청 기간<span class="required">*</span></td>
              <td class="w-75per p-3">
                <div class="w-50per">
                  <!-- 멀티 날짜 custom -->
                  <Field
                    v-model="initialValues.sugang.chasuPeroid"
                    id="chasuPeroid"
                    name="chasuPeroid"
                    label="수강 신청 기간"
                    type="text"
                    v-slot="{ field, errors }"
                    rules="required|multidateCheck">
                    <Datepicker class="error" v-model="initialValues.sugang.chasuPeroid" v-bind="field" range multi-calendars :format="funcFormat" @update:modelValue="setChasuDate">
                      <template #dp-input="{ value }">
                        <input
                          class="dp__pointer dp__input_readonly dp__input dp__input_icon_pad dp__input_reg"
                          id="chasuPeroid"
                          :class="{ error: errors.length > 0 ? true : false }"
                          type="text"
                          :value="value"
                          placeholder="기간을 선택해주세요" />

                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" class="dp__icon dp__input_icon dp__input_icons">
                          <path
                            d="M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"></path>
                          <path d="M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"></path>
                          <path d="M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"></path>
                          <path d="M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"></path>
                        </svg>
                      </template>
                    </Datepicker>
                  </Field>
                  <ErrorMessage class="error-text-size" name="chasuPeroid" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="w-20per txt-center label p-2">대리인신청가능 <span class="required">*</span></td>
              <td class="w-75per p-3">
                <Field id="isProxy" name="isProxy" label="대리인신청가능" v-model="initialValues.sugang.isProxy" rules="required" v-slot="{ field, errors }">
                  <b-form-radio-group
                    v-model="initialValues.sugang.isProxy"
                    v-bind="field"
                    name="isProxy"
                    :state="errors[0] ? false : null"
                    :options="radioOptionsIsProxy"
                    class="cursor"
                    id="isProxy">
                  </b-form-radio-group>
                  <b-form-invalid-feedback :state="errors[0] ? false : null" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                </Field>
              </td>
            </tr>
            <tr>
              <td class="w-20per txt-center label p-2">SPAC 사용 <span class="required">*</span></td>
              <td class="w-75per p-3">
                <Field id="isSpac" name="isSpac" label="SPAC 사용" v-model="initialValues.sugang.isSpac" rules="required" v-slot="{ field, errors }">
                  <b-form-radio-group v-model="initialValues.sugang.isSpac" v-bind="field" name="isSpac" :state="errors[0] ? false : null" :options="radioOptions" class="cursor" id="isSpac">
                  </b-form-radio-group>
                  <b-form-invalid-feedback :state="errors[0] ? false : null" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                </Field>
              </td>
            </tr>
            <tr>
              <td class="w-20per txt-center label p-2">FAQ 관리 <span class="required">*</span></td>
              <td class="w-75per p-3">
                <Field id="isFaq" name="isFaq" label="FAQ 사용" v-model="initialValues.sugang.isFaq" rules="required" v-slot="{ field, errors }">
                  <b-form-radio-group
                    v-model="initialValues.sugang.isFaq"
                    v-bind="field"
                    name="isFaq"
                    :state="errors[0] ? false : null"
                    :options="optionFaqUseList"
                    class="cursor"
                    id="isFaq">
                  </b-form-radio-group>
                  <b-form-invalid-feedback :state="errors[0] ? false : null" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                </Field>
                <Field v-if="initialValues.sugang.isFaq === 'Y'" v-model="selected" id="faqList" name="faqList" rules="checkBox" label="FAQ 관리" v-slot="{ field, errors }">
                  <br />
                  <b-form-checkbox-group id="faqList" v-model="selected" v-bind="field" :options="optionFaqList" @update:modelValue="faqChange" :state="errors[0] ? false : null">
                  </b-form-checkbox-group>
                  <b-form-invalid-feedback :state="errors[0] ? false : null" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                </Field>
              </td>
            </tr>
            <tr>
              <td class="w-20per txt-center label p-2">교육과정 안내 관리</td>
              <td class="w-75per p-3">
                <Field id="isCourseMenu" name="isCourseMenu" label="교육과정 안내 사용" v-model="initialValues.sugang.isCourseMenu" rules="required" v-slot="{ field, errors }">
                  <b-form-radio-group
                    v-model="initialValues.sugang.isCourseMenu"
                    v-bind="field"
                    name="isCourseMenu"
                    :state="errors[0] ? false : null"
                    :options="optionMenuList"
                    class="cursor"
                    id="isCourseMenu">
                  </b-form-radio-group>
                  <b-form-invalid-feedback :state="errors[0] ? false : null" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                </Field>
                <Field v-if="initialValues.sugang.isCourseMenu === 'Y'" id="menuList" ref="menuListRef" name="menuList" label="메뉴 관리" v-slot="{ field, errors }">
                  <br />
                  <div class="d-flex">
                    <b-button id="menuList" variant="primary" :class="{ error: errors.length > 0 ? true : false }" @click="openMenuModal">교육과정 안내 관리</b-button>
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="ps-2 pm-2"> {{ funcChangeMenuData(initialValues.menuList) }} </span>
                    </div>
                    <input v-model="initialValues.menuList" type="hidden" v-bind="field" />
                  </div>
                </Field>
              </td>
            </tr>
            <tr>
              <td class="w-20per txt-center label p-2">
                통합수강신청 과정별 <span class="required">*</span><br />
                중복 신청 추가 설정
              </td>
              <td class="w-75per p-3">
                <div class="no-wrap">
                  <b-form-radio-group v-model="isDuplicate" class="cursor d-inline-block" :options="duplicateList" @change="Duplicate($event)"> </b-form-radio-group>
                  <span style="color: red"> ※ 사용시 ITM-Global, CTM-Solutions 수강신청의 중복 신청 설정에 추가로 설정이 적용됩니다.</span>
                </div>
                <div v-if="isDuplicate === 'Y'">
                  <br />
                  <div class="d-flex">
                    <div class="w-6per d-inline-block">
                      <b-form-input v-model="initialValues.sugang.distinctCnt" type="number" min="1"> </b-form-input>
                    </div>
                    <span class="ms-2 d-flex align-items-center"> 개 과정 중복 신청 가능</span>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="w-20per txt-center label p-2">다음 차수 정보 <span class="required">*</span></td>
              <td class="w-75per p-3">
                <div class="d-flex flex-column">
                  <Field id="isNextChasu" name="isNextChasu" label="다음 차수 정보" v-model="initialValues.sugang.isNextChasu" rules="required" v-slot="{ field, errors }">
                    <b-form-radio-group
                      v-model="initialValues.sugang.isNextChasu"
                      class="cursor"
                      id="isNextChasu"
                      v-bind="field"
                      :options="chasuList"
                      name="isNextChasu"
                      :state="errors[0] ? false : null">
                    </b-form-radio-group>
                    <b-form-invalid-feedback :state="errors[0] ? false : null" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                  </Field>
                </div>
              </td>
            </tr>
            <tr v-show="initialValues.sugang.isNextChasu === 'Y'">
              <td class="w-20per txt-center label p-2">다음 차수 명 <span class="required">*</span></td>
              <td class="w-75per p-3">
                <div class="w-50per d-inline-block">
                  <Field
                    v-model="initialValues.sugang.nextChasuName"
                    id="nextChasuName"
                    name="nextChasuName"
                    label="플랫폼명"
                    :rules="initialValues.sugang.isNextChasu === 'Y' ? 'required' : ''"
                    v-slot="{ field, errors }">
                    <b-form-input
                      v-model="initialValues.sugang.nextChasuName"
                      v-bind="field"
                      id="nextChasuName"
                      type="text"
                      placeholder="다음 차수 명을 입력해주세요"
                      :state="errors[0] ? false : null">
                    </b-form-input>
                    <b-form-invalid-feedback :state="errors[0] ? false : null" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                  </Field>
                </div>
              </td>
            </tr>
            <tr v-show="initialValues.sugang.isNextChasu === 'Y'">
              <td class="w-20per txt-center label p-2">다음 차수 기간 <span class="required">*</span></td>
              <td class="w-75per p-3">
                <div class="w-50per">
                  <Field
                    id="nextChasuPeroid"
                    name="nextChasuPeroid"
                    label="다음 차수 기간"
                    type="text"
                    v-model="initialValues.sugang.nextChasuPeroid"
                    v-slot="{ field, errors }"
                    :rules="initialValues.sugang.isNextChasu === 'Y' ? 'required|multidateCheck' : ''">
                    <Datepicker class="error" v-model="initialValues.sugang.nextChasuPeroid" v-bind="field" range multi-calendars :format="funcFormat" @update:modelValue="setNextChasuDate">
                      <template #dp-input="{ value }">
                        <input
                          id="nextChasuPeroid"
                          class="dp__pointer dp__input_readonly dp__input dp__input_icon_pad dp__input_reg"
                          :class="{ error: errors.length > 0 ? true : false }"
                          type="text"
                          :value="value"
                          placeholder="기간을 선택해주세요" />

                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" class="dp__icon dp__input_icon dp__input_icons">
                          <path
                            d="M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"></path>
                          <path d="M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"></path>
                          <path d="M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"></path>
                          <path d="M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"></path>
                        </svg>
                      </template>
                    </Datepicker>
                  </Field>
                  <ErrorMessage class="error-text-size" name="nextChasuPeroid" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="w-20per txt-center label p-2">팝업 등록 사용여부 <span class="required">*</span></td>
              <td class="w-75per p-3">
                <div class="d-flex flex-column">
                  <Field id="isPopup" v-model="initialValues.sugang.isPopup" name="isPopup" label="다음 차수 정보" rules="required" v-slot="{ field, errors }">
                    <b-form-radio-group
                      v-model="initialValues.sugang.isPopup"
                      v-bind="field"
                      class="cursor"
                      id="isPopup"
                      :options="chasuList"
                      name="isPopup"
                      :state="errors[0] ? false : null">
                    </b-form-radio-group>
                    <b-form-invalid-feedback :state="errors[0] ? false : null" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                  </Field>
                </div>
              </td>
            </tr>
            <tr v-show="initialValues.sugang.isPopup === 'Y'">
              <td class="w-20per txt-center label p-2">팝업 관리 <span class="required">*</span></td>
              <td class="w-75per p-3">
                <div class="d-flex align-items-center">
                  <b-button type="button" variant="primary" @click="addPopupItem">+ 팝업추가</b-button>
                  <span class="ms-3">※ 팝업을 여러 개 등록하고 순서를 조정할 수 있습니다.</span>
                </div>
                <div class="mt-2 popup-guide-copy">※ 팝업 1이 가장 먼저 노출되며, 아래로 갈수록 다음 순서로 노출됩니다.</div>
              </td>
            </tr>
            <template v-if="initialValues.sugang.isPopup === 'Y'" v-for="(popup, idx) in popupList" :key="popup.formKey">
              <tr class="popup-section-start">
                <td class="w-20per txt-center label p-2 popup-section-label">
                  <div class="popup-section-badge">팝업 {{ idx + 1 }}</div>
                </td>
                <td class="w-75per p-3 popup-section-body popup-section-body-start">
                  <div class="d-flex align-items-center justify-content-between flex-wrap">
                    <div class="popup-sort-copy">노출 순서 {{ popup.sort }}</div>
                    <div>
                      <b-button type="button" variant="outline-primary" size="sm" class="ms-3" :disabled="idx === 0" @click="movePopupItem(idx, -1)">위로</b-button>
                      <b-button type="button" variant="outline-primary" size="sm" class="ms-2" :disabled="idx === popupList.length - 1" @click="movePopupItem(idx, 1)">아래로</b-button>
                      <b-button type="button" variant="danger" size="sm" class="ms-2" @click="removePopupItem(idx)">삭제</b-button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2 popup-section-label-sub">팝업 파일 <span class="required">*</span></td>
                <td class="w-75per p-3 popup-section-body">
                  <div class="w-70per mt-2">
                    <div class="d-flex align-items-center">
                      <div class="w-60per" :class="popup.popupImageName === '' ? 'd-inline-block' : 'd-none'">
                        <input class="form-control" type="file" :id="`popupImage${idx}`" accept=".png, .jpg, .jpeg" @change="event => popImageFileChange(event, idx)" />
                      </div>
                      <div v-show="popup.popupImageUrl && popup.popupImageName" class="d-flex align-items-center">
                        <span class="hyperlink" @click="preView(popup.popupImageUrl)">{{ popup.popupImageName }}</span>
                      </div>
                      <b-button type="button" v-show="popup.popupImageUrl && popup.popupImageName" variant="danger" class="ms-2 align-top" @click="deletePopupImage(idx)">삭제</b-button>
                    </div>
                    <div class="mt-2">※ jpg, png,jpeg 파일만 등록 가능(650 * 650 , 미등록시 미출력)</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2 popup-section-label-sub">팝업 이미지링크</td>
                <td class="w-75per p-3 popup-section-body">
                  <div class="d-flex mt-2">
                    <div class="w-70per">
                      <b-form-input v-model="popup.popupLink" type="text" placeholder="이미지와 연결되는 링크를 입력해주세요"> </b-form-input>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2 popup-section-label-sub popup-section-label-end">팝업 노출기간 <span class="required">*</span></td>
                <td class="w-75per p-3 popup-section-body popup-section-body-end">
                  <div class="w-50per">
                    <Datepicker class="error" v-model="popup.popupPeroid" range multi-calendars :format="funcFormat" @update:modelValue="value => setPopupDate(idx, value)">
                      <template #dp-input="{ value }">
                        <input class="dp__pointer dp__input_readonly dp__input dp__input_icon_pad dp__input_reg" type="text" :value="value" placeholder="기간을 선택해주세요" />
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" class="dp__icon dp__input_icon dp__input_icons">
                          <path
                            d="M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"></path>
                          <path d="M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"></path>
                          <path d="M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"></path>
                          <path d="M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"></path>
                        </svg>
                      </template>
                    </Datepicker>
                  </div>
                </td>
              </tr>
            </template>
            <tr>
              <td class="w-20per txt-center label p-2">인원정보 노출여부 <span class="required">*</span></td>
              <td class="w-75per p-3">
                <Field id="isWaitInfo" name="isWaitInfo" label="인원정보 노출여부" v-model="initialValues.sugang.isWaitInfo" rules="required" v-slot="{ field, errors }">
                  <b-form-radio-group
                    v-model="initialValues.sugang.isWaitInfo"
                    v-bind="field"
                    name="isWaitInfo"
                    :state="errors[0] ? false : null"
                    :options="radioOptions"
                    class="cursor"
                    id="isWaitInfo">
                  </b-form-radio-group>
                  <b-form-invalid-feedback :state="errors[0] ? false : null" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                </Field>
              </td>
            </tr>
            <tr>
              <td class="w-20per txt-center label p-2">배너 노출 여부 <span class="required">*</span></td>
              <td class="w-75per p-3">
                <Field id="isBanner" name="isBanner" label="배너 노출 여부" v-model="initialValues.sugang.isBanner" rules="required" v-slot="{ field, errors }">
                  <b-form-radio-group
                    v-model="initialValues.sugang.isBanner"
                    v-bind="field"
                    name="isBanner"
                    :state="errors[0] ? false : null"
                    :options="radioOptions"
                    class="cursor"
                    id="isBanner">
                  </b-form-radio-group>
                  <b-form-invalid-feedback :state="errors[0] ? false : null" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                </Field>
              </td>
            </tr>
          </tbody>
        </table>

        <FieldArray name="courseList" v-slot="{ fields }" ref="courseListRef">
          <div class="d-flex justify-content-between align-items-center mt-5 mb-2">
            <div class="d-inline-block">
              <h4 class="title">※과정관리</h4>
            </div>
          </div>

          <div class="d-flex flex-column" :class="{ 'mt-4': idx !== 0 }" v-for="(field, idx) in fields" :key="field.key">
            <div class="class-manage-card p-3" :id="`courceForm${idx}`">
              <table class="info">
                <tbody>
                  <tr>
                    <td class="w-5per txt-center label" rowspan="7">과정{{ idx + 1 }}</td>
                    <td class="w-20per txt-center label p-2">사용여부 <span class="required">*</span></td>
                    <td class="w-75per p-3">
                      <Field
                        :id="`courseList${idx}.isUse`"
                        v-model="initialValues.courseList[idx].isUse"
                        :name="`courseList${idx}.isUse`"
                        label="사용여부"
                        rules="required"
                        v-slot="{ field, errors }">
                        <b-form-radio-group
                          class="cursor"
                          :id="`courseList${idx}.isUse`"
                          v-model="initialValues.courseList[idx].isUse"
                          :state="errors[0] ? false : null"
                          v-bind="field"
                          :options="completeList"
                          :name="`courseList${idx}.isUse`">
                        </b-form-radio-group>
                        <b-form-invalid-feedback :state="errors[0] ? false : null" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                      </Field>
                    </td>
                  </tr>

                  <tr v-show="initialValues.courseList[idx].isUse === 'Y'">
                    <td class="w-20per txt-center label p-2">메뉴명 <span class="required">*</span></td>
                    <td class="w-75per p-3">
                      <div class="w-50per d-inline-block">
                        <Field
                          v-model="initialValues.courseList[idx].courseName"
                          :id="`courseList${idx}.courseName`"
                          :name="`courseList[${idx}].courseName`"
                          label="과정명"
                          :rules="initialValues.courseList[idx].isUse === 'Y' ? 'required' : ''"
                          v-slot="{ field, errors }">
                          <b-form-input
                            v-model="initialValues.courseList[idx].courseName"
                            :id="`courseList${idx}.courseName`"
                            v-bind="field"
                            placeholder="과정명을 입력하세요."
                            :state="errors[0] ? false : null">
                          </b-form-input>
                          <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                        </Field>
                      </div>
                    </td>
                  </tr>
                  <tr v-show="initialValues.courseList[idx].isUse === 'Y'">
                    <td class="txt-center label p-2">연결 관리자 <span class="required">*</span></td>
                    <td class="w-75per p-3">
                      <div>
                        <div class="w-35per d-inline-block align-top">
                          <Field
                            :id="`courseList${idx}.courseType`"
                            :name="`courseList[${idx}].courseType`"
                            v-model="initialValues.courseList[idx].courseType"
                            label="연결 관리자"
                            :rules="initialValues.courseList[idx].isUse === 'Y' ? 'required' : ''"
                            v-slot="{ field, errors }">
                            <b-form-select
                              class="search-selectbox"
                              :id="`courseList${idx}.courseType`"
                              v-model="initialValues.courseList[idx].courseType"
                              v-bind="field"
                              :options="compConnectionList"
                              @update:modelValue="changeConectionSelect(initialValues.courseList[idx], idx)"
                              :state="errors[0] ? false : null"></b-form-select>
                            <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                          </Field>
                        </div>
                        <div class="w-35per d-inline-block ms-2 align-top">
                          <Field
                            v-model="initialValues.courseList[idx].codeConfirm"
                            :id="`courseList${idx}.codeConfirm`"
                            :name="`courseList${idx}.codeConfirm`"
                            v-slot="{ field }"
                            label="코드확인">
                            <input v-model="initialValues.courseList[idx].codeConfirm" type="hidden" hidden v-bind="field" />
                          </Field>
                          <Field
                            :id="`courseList${idx}.code`"
                            :name="`courseList[${idx}].code`"
                            label="코드"
                            v-model="initialValues.courseList[idx].code"
                            :ref="el => (conectionRef[idx] = el)"
                            :rules="
                              initialValues.courseList[idx].isUse === 'Y'
                                ? `required|isDupTarget:courseList${idx}|peroidCheck:${initialValues.sugang.startDate},${initialValues.sugang.endDate},${initialValues.courseList[idx]['courseDt']}`
                                : ''
                            "
                            v-slot="{ field, errors }">
                            <b-form-input
                              v-model="initialValues.courseList[idx].code"
                              :id="`courseList${idx}.code`"
                              type="text"
                              v-bind="field"
                              placeholder="코드를 입력해주세요"
                              @update:modelValue="changeCodeValue(idx)"
                              @keyup.enter="checkSugangCode(initialValues.courseList[idx], idx)"
                              :state="errors[0] ? false : null">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                          </Field>
                          <Field
                            :id="`courseList${idx}.courseDt`"
                            :name="`courseList[${idx}].courseDt`"
                            :label="`과정${idx} 수강신청 기간`"
                            :ref="el => (courseDtRef[idx] = el)"
                            v-model="initialValues.courseList[idx].courseDt"
                            :rules="initialValues.courseList[idx].isUse === 'Y' ? 'required' : ''"
                            v-slot="{ field }">
                            <input type="hidden" v-model="initialValues.courseList[idx].courseDt" v-bind="field" />
                          </Field>
                          <ErrorMessage class="error-text-size" :name="`courseList[${idx}].courseDt`" />
                        </div>
                        <b-button variant="primary" class="ms-2 align-top" @click="checkSugangCode(initialValues.courseList[idx], idx)">코드확인</b-button>
                        <b-button variant="primary" class="ms-2 align-top" @click="isGuideModal = true">가이드</b-button>
                      </div>
                    </td>
                  </tr>
                  <tr v-show="initialValues.courseList[idx].isUse === 'Y'">
                    <td class="txt-center label p-2">로드맵 <span class="required">*</span></td>
                    <td class="w-75per p-3">
                      <div class="w-35per d-inline-block align-top">
                        <Field
                          v-model="initialValues.courseList[idx].roadMapType"
                          :id="`courseList${idx}.roadMapType`"
                          :name="`courseList${idx}.roadMapType`"
                          label="로드맵"
                          :rules="initialValues.courseList[idx].isUse === 'Y' ? 'required' : ''"
                          :ref="el => (roadMapRef[idx] = el)"
                          v-slot="{ field, errors }">
                          <b-form-select
                            class="search-selectbox"
                            :id="`courseList${idx}.roadMapType`"
                            v-model="initialValues.courseList[idx].roadMapType"
                            :state="errors[0] ? false : null"
                            @update:modelValue="changeRoadMapType(initialValues.courseList[idx], idx)"
                            :options="roadMapTypeList"
                            v-bind="field">
                          </b-form-select>
                          <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                        </Field>
                      </div>
                    </td>
                  </tr>
                  <tr v-show="initialValues.courseList[idx].isUse === 'Y' && initialValues.courseList[idx].roadMapType === 'ctm_image'">
                    <td class="txt-center label p-2">로드맵 이미지 <span class="required">*</span></td>
                    <td class="w-75per p-3">
                      <div class="d-flex">
                        <div class="w-40per" v-show="!initialValues.courseList[idx].roadMapUrl">
                          <Field
                            v-model="initialValues.courseList[idx].roadMapUrl"
                            :id="`courseList${idx}.roadMapUrl`"
                            :name="`courseList${idx}.roadMapUrl`"
                            label="로드맵 이미지"
                            :ref="el => (courseListRoadMapImgRef[idx] = el)"
                            type="text"
                            :rules="initialValues.courseList[idx].isUse === 'Y' && initialValues.courseList[idx].roadMapType === 'ctm_image' ? 'required' : ''"
                            v-slot="{ field, errors }">
                            <input type="hidden" v-bind="field" />
                            <input class="form-control" :class="{ 'is-invalid': errors[0] ? true : false }" type="file" :id="`ctmImage${idx}`" accept=".png, .jpg, .jpeg" />
                            <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                          </Field>
                        </div>
                        <div v-show="initialValues.courseList[idx].roadMapUrl && initialValues.courseList[idx].roadMapName" class="d-flex align-items-center">
                          <span class="hyperlink" @click="preView(initialValues.courseList[idx].roadMapUrl)">{{ initialValues.courseList[idx].roadMapName }}</span>
                        </div>
                        <b-button
                          v-show="initialValues.courseList[idx].roadMapUrl && initialValues.courseList[idx].roadMapName"
                          variant="danger"
                          class="ms-2"
                          @click="deleteRoadMapImage(idx)"
                          >삭제하기</b-button
                        >
                      </div>
                      <div class="d-flex flex-column mt-2">
                        <div class="d-flex align-items-center">
                          <span>※ jpg, png, jpeg 파일만 등록 가능(해상도에 맞춰 올려주세요) </span>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-show="initialValues.courseList[idx].isUse === 'Y'">
                    <td class="txt-center label p-2">수료기준 사용여부<span class="required"> *</span></td>
                    <td class="w-75per p-3">
                      <Field
                        v-model="initialValues.courseList[idx].isCompletion"
                        :id="`courseList${idx}.isCompletion`"
                        :name="`courseList${idx}.isCompletion`"
                        label="수료기준 사용여부"
                        :rules="initialValues.courseList[idx].isUse === 'Y' ? 'required' : ''"
                        :ref="el => (completionListRef[idx] = el)"
                        v-slot="{ field, errors }">
                        <b-form-radio-group
                          v-model="initialValues.courseList[idx].isCompletion"
                          class="cursor"
                          :id="`courseList${idx}.isCompletion`"
                          :options="completeList"
                          :name="`courseList${idx}.isCompletion`"
                          :state="errors[0] ? false : null"
                          v-bind="field">
                        </b-form-radio-group>
                        <b-form-invalid-feedback :state="errors[0] ? false : null" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                      </Field>
                    </td>
                  </tr>
                  <tr v-show="initialValues.courseList[idx].isCompletion === 'Y' && initialValues.courseList[idx].isUse === 'Y'">
                    <td class="txt-center label p-2">수료기준 <span class="required">*</span></td>
                    <td class="w-75per p-3">
                      <div class="d-flex flex-column">
                        <div class="mb-3">
                          <div class="txt-right">
                            <b-button variant="primary" @click="resetTemplate(idx)">초기화</b-button>
                          </div>
                        </div>
                        <Field
                          v-model="initialValues.courseList[idx].completionText"
                          :id="`courseList${idx}.completionText`"
                          :name="`courseList${idx}.completionText`"
                          label="수료기준"
                          type="text"
                          v-slot="{ field, errors }"
                          :rules="initialValues.courseList[idx].isCompletion === 'Y' && initialValues.courseList[idx].isUse === 'Y' ? 'required' : ''">
                          <MyEdit
                            :idx="idx"
                            :ref="el => (tinyeditorRef[idx] = el)"
                            :id="`completeStandard${idx + 1}`"
                            :editData="initialValues.courseList[idx].completionText"
                            :error="errors[0]"
                            @change="onChangeEditor"></MyEdit>
                          <input type="hidden" v-bind="field" />
                        </Field>
                        <ErrorMessage class="error-text-size" :name="`courseList${idx}.completionText`" />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </FieldArray>

        <div class="txt-right mt-3">
          <b-button variant="primary" :disabled="btnLoading ? true : false" @click="funcAddArray">+ 과정추가</b-button>
          <b-button variant="danger" :disabled="btnLoading ? true : false" class="ms-2" @click="funcRemoveArray">- 과정삭제</b-button>
          <b-button variant="primary" class="ms-2" @click="backConfirm">돌아가기</b-button>
          <b-button variant="primary" :disabled="btnLoading ? true : false" class="ms-2" @click="onSubmit(values)">저장하기</b-button>
        </div>
      </Form>
    </div>
  </div>
  <h1 class="center" v-else>
    <Loading v-if="mainLoaiding"></Loading>
  </h1>
  <CodeGuide :visible="isGuideModal" @closeModal="onGuideCloseModal"></CodeGuide>
  <CompanyList :visible="isCompanyModal" @closeModal="onCloseCompanyModal" @selectModal="funcRowSelect"></CompanyList>
  <ManageMenu :visible="isMenuModal" :list="initialValues.menuList" @closeModal="onCloseMenuModal" @returnData="onReturnData"></ManageMenu>
</template>

<script setup>
import { reactive, ref } from '@vue/reactivity';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { computed, nextTick, onBeforeMount, onMounted, watch, defineAsyncComponent } from '@vue/runtime-core';
import _ from 'lodash';
import CompanyList from '@/components/CompanyList.vue';
import ManageMenu from '@/components/ManageMenu.vue';
import CodeGuide from '@/components/CodeGuide.vue';
import { codeCheckApi, fileUploadApi, faqListApi, sugangRegisterApi, sugangDetailApi, sugangModifyApi } from '@/api/integrateapi/index';
import { dateToString } from '@/utils/util';
import { checkItmCode } from '@/api/itmapi/index';
import { checkCtmSugangCode } from '@/api/ctmapi/index';
import { useRoute } from 'vue-router';
import { userSite } from '@/plugins/axios/apiUrl';
const MyEdit = defineAsyncComponent(() => import('@/components/TinyEditor.vue'));

////////////////////////////////////////////////////// data //////////////////////////////////////////////////////
const FORM_TYPE = {
  INSERT: 1,
  MODIFY: 2,
};
const type = ref(FORM_TYPE.INSERT);

const platfomrAddForm = ref(null);
const courseListRef = ref(null);
const companyNameRef = ref(null);
const codeRef = ref(null);
const clientImageRef = ref(null);

const conectionRef = ref([]);
const roadMapRef = ref([]);
const companyLogoUrlRef = ref(null);
const menuListRef = ref(null);
const courseListImageRef = ref([]);
const courseListRoadMapImgRef = ref([]);
const completionListRef = ref([]);
const tinyeditorRef = ref([]);
const courseDtRef = ref([]);
const siteUrl = ref('');
const popupList = ref([]);
let popupFormKeySeq = 0;

const btnLoading = ref(false);

const roadMapTypeList = reactive([
  { value: 'ctm', text: '전화영어 로드맵' },
  { value: 'ctm_image', text: '이미지 업로드' },
  { value: 'x', text: '사용하지 않음' },
]);

const selected = ref([]);
const imgReg = /(jpg|png|jpeg)/g;

const router = useRouter();

const completTemplete = `
<div style="margin: 0 auto; background-color: #fff; width: 480px; padding: 20px;">
  <h1 style="font-size: 17.5px; color: #1e78ff; line-height: 27px;">[출석률]</h1>
  <p style="font-size: 16.5px; color: #000000; line-height: 27px;">80% 이상 달성(총 15회 수업 중 12회 이상 출석 필수)</p>
  <p style="font-size: 16.5px; color: #000000; line-height: 27px; margin-top: 20px; margin-bottom: 0;">1) 지각/결석 관련</p>
  <ul style="margin-top: 0; margin-bottom: 0; padding-left: 10px;">
    <li style="list-style: none; padding-left: 0;">- 10분 이상 지각 시 결석 처리</li>
    <li style="list-style: none; padding-left: 0;">- 2회 이상 지각 시 결석 1회로 간주</li>
  </ul>
  <h1 style="font-size: 17.5px; color: #1e78ff; line-height: 27px; margin-top: 20px;">[향상도]</h1>
  <p style="font-size: 16.5px; color: #000000; line-height: 27px;">사전&amp;사후 SPAC^ TEST 응시</p>
  <h1 style="font-size: 17.5px; color: #1e78ff; line-height: 27px; margin-top: 20px;">[패널티]</h1>
  <p style="font-size: 16.5px; color: #000000; line-height: 27px;">미수료 시 종료 후 8만원 급여공제</p>
</div>
`;
const courseArray = ref([]);
let initialValues = {
  sugang: {
    companyIdx: -1,
    companyName: '',
    code: '', //페이지 code
    dupConfirmCode: 'N', //페이지 code 중복확인
    companyLogoUrl: '', // 고객사 로고
    companyLogoName: '',
    platformName: '', // 플랫폼명
    chasuName: '', //차수명
    chasuPeroid: [], //차수기간
    startDate: '',
    endDate: '',
    isNextChasu: 'Y', //다음 차수 사용여부
    nextChasuName: '', //다음 차수명
    nextChasuPeroid: [], //다음 차수 기간
    nextChasuStartDate: '', //다음 차수 시작일
    nextChasuEndDate: '', //다음 차수 종료일
    isPopup: 'Y', //팝업 사용여부
    isSpac: 'N',
    isFaq: 'N',
    isProxy: 'N',
    isCourseMenu: 'N',
    isTeacher: 'N',
    isClose: 'N',
    distinctCnt: 0,
    isWaitInfo: 'N',
    isBanner: 'Y',
  },
  courseList: [
    {
      code: '',
      codeConfirm: 'N',
      completionText: completTemplete,
      completionInfo: {},
      courseName: '',
      courseType: '',
      isCompletion: 'Y',
      isUse: 'N',
      roadMapType: 'x',
      roadMapUrl: '',
      roadMapName: '',
      courseStDt: '',
      courseEndDt: '',
      courseDt: '',
    },
  ],
  menuList: [],
  faqList: [],
  faq: [],
  selected: [],
};
const isDuplicate = ref('N');
const isCompanyModal = ref(false);
const isMenuModal = ref(false);
const isGuideModal = ref(false);

const radioOptions = reactive([
  { text: '노출', value: 'Y' },
  { text: '비노출', value: 'N' },
]);

const radioOptionsIsProxy = reactive([
  { text: '사용', value: 'Y' },
  { text: '사용안함', value: 'N' },
]);

const optionFaqUseList = reactive([
  {
    value: 'Y',
    text: '사용',
  },
  {
    value: 'N',
    text: '사용 안함',
  },
]);

const optionFaqList = reactive([]);

const optionMenuList = reactive([
  {
    value: 'Y',
    text: '사용',
  },
  {
    value: 'N',
    text: '사용 안함',
  },
]);

const chasuList = reactive([
  {
    value: 'Y',
    text: '사용',
  },
  {
    value: 'N',
    text: '사용 안함',
  },
]);

const duplicateList = reactive([
  {
    value: 'Y',
    text: '사용',
  },
  {
    value: 'N',
    text: '사용 안함',
  },
]);

const completeList = reactive([
  {
    value: 'Y',
    text: '사용',
  },
  {
    value: 'N',
    text: '사용 안함',
  },
]);

const mainLoaiding = ref(false);
const route = useRoute();
////////////////////////////////////////////////////// data //////////////////////////////////////////////////////

//store
////////////////////////////////////////////////////// store //////////////////////////////////////////////////////
const store = useStore();
////////////////////////////////////////////////////// store //////////////////////////////////////////////////////

////////////////////////////////////////////////////// func //////////////////////////////////////////////////////

const setInit = async () => {
  //고객사 로고 이벤트 등록
  fileUpload();
  setPopupList([]);
  //로드맵 이미지 이벤트 등록
  initialValues.courseList.forEach((_, index) => {
    roadImageUpload(index);
  });

  //faq 리스트 조회
  try {
    await getFaqList();
    await setFaq();
  } catch (error) {
    console.error('get faq error : ', error);
  }
};

const splitImage = imgUrl => {
  let name = '';
  if (imgUrl) {
    name = imgUrl.split('/')[5];
  }

  return name;
};

const createPopupItem = popup => {
  return {
    formKey: `popup-${popupFormKeySeq++}`,
    idx: popup?.idx,
    sugangIdx: popup?.sugangIdx,
    popupImageUrl: popup?.popupImageUrl || '',
    popupImageName: splitImage(popup?.popupImageUrl),
    popupLink: popup?.popupLink || '',
    popupPeroid: popup?.popupStartDate && popup?.popupEndDate ? [new Date(popup.popupStartDate), new Date(popup.popupEndDate)] : [],
    popupStartDate: popup?.popupStartDate || '',
    popupEndDate: popup?.popupEndDate || '',
    sort: popup?.sort || 1,
  };
};

const syncPopupSort = () => {
  popupList.value.forEach((popup, index) => {
    popup.sort = index + 1;
  });
};

const setPopupList = list => {
  if (list && list.length > 0) {
    popupList.value = _.sortBy(list, popup => popup.sort || 0).map(item => createPopupItem(item));
  } else {
    popupList.value = [createPopupItem()];
  }
  syncPopupSort();
};

const setModifyInit = async platformData => {
  //FORM_TYPE 변경
  type.value = FORM_TYPE.MODIFY;
  //수강정보 , 메뉴관리, faq 리스트, 과정관리
  const { sugang, menuList, faqList, courseList, popupList: popupItems = [] } = platformData;

  //수강정보(sugang) set
  setSugang(sugang);

  // 메뉴관리(menuList) set
  setMenuList(menuList);

  // faq 리스트(faqList) set

  setFaqList(faqList);
  setPopupList(popupItems);

  courseArray.value = courseList;
};

//수강정보 세팅
const setSugang = sugang => {
  initialValues.sugang.dupConfirmCode = 'Y';
  initialValues.sugang.companyIdx = sugang.companyIdx;
  initialValues.sugang.companyName = sugang.companyName;
  initialValues.sugang.code = sugang.code;
  initialValues.sugang.companyLogoUrl = sugang.companyLogoUrl;
  initialValues.sugang.companyLogoName = splitImage(sugang.companyLogoUrl);
  initialValues.sugang.platformName = sugang.platformName;
  initialValues.sugang.chasuName = sugang.chasuName;
  initialValues.sugang.isClose = sugang.isClose;
  initialValues.sugang.distinctCnt = sugang.distinctCnt;
  if (initialValues.sugang.distinctCnt != 0) {
    isDuplicate.value = 'Y';
  } else {
    isDuplicate.value = 'N';
  }
  //차수 기간은 startDate, endDater 관리하고 chasuPeroid를 통해 기간을세팅해야 DatePicker를 사용할 수 있다.
  initialValues.sugang.startDate = sugang.startDate;
  initialValues.sugang.endDate = sugang.endDate;
  initialValues.sugang.chasuPeroid = [new Date(sugang.startDate), new Date(sugang.endDate)];
  initialValues.sugang.isProxy = sugang.isProxy;
  initialValues.sugang.isSpac = sugang.isSpac;
  initialValues.sugang.isWaitInfo = sugang.isWaitInfo;
  initialValues.sugang.isBanner = sugang.isBanner;
  initialValues.sugang.isCourseMenu = sugang.isCourseMenu;
  initialValues.sugang.isFaq = sugang.isFaq;
  initialValues.sugang.isTeacher = sugang.isTeacher;
  initialValues.sugang.isNextChasu = sugang.isNextChasu;
  initialValues.sugang.nextChasuName = sugang.nextChasuName;
  //다음 차수 기간 관리하고 nextChasuPeroid를 통해 기간을세팅해야 DatePicker를 사용할 수 있다.
  initialValues.sugang.nextChasuStartDate = sugang.nextChasuStartDate;
  initialValues.sugang.nextChasuEndDate = sugang.nextChasuEndDate;
  initialValues.sugang.nextChasuPeroid = [new Date(sugang.nextChasuStartDate), new Date(sugang.nextChasuEndDate)];
  initialValues.sugang.isPopup = sugang.isPopup;
};

//faq 관리
const setFaqList = async faqList => {
  try {
    await getFaqList();
    if (faqList.length === 0) {
      await setFaq();
    }
  } catch (error) {
    console.error('getFaqList error : ', error);
    return false;
  }
  if (faqList.length > 0) {
    initialValues.faqList = faqList;
    selected.value = faqList.filter(item => item.isUse === 'Y').map(faq => faq.faqCategoryIdx);
  }
};

//메뉴관리 세팅
const setMenuList = menuList => {
  initialValues.menuList = menuList;
};

const setCourseList = async courseList => {
  initialValues.courseList.length = 0;
  if (courseListRef.value) {
    for (let i = 0; i < courseList.length; i++) {
      let courseDt = '';

      if (courseList[i]['courseType'] === 'ctm') {
        const { data } = await apiCtmSugangCode(courseList[i]['code']);
        const { sugangStartDate, sugangEndDate } = data;
        courseList[i]['courseDt'] = `${sugangStartDate}~${sugangEndDate}`;
        courseDt = courseList[i]['courseDt'];
      } else if (courseList[i]['courseType'] === 'itm') {
        const { data } = await apiItmSugangCode(courseList[i]['code']);
        const { sugangStartDate, sugangEndDate } = data;
        courseList[i]['courseDt'] = `${sugangStartDate}~${sugangEndDate}`;
        courseDt = courseList[i]['courseDt'];
      }

      const { push } = courseListRef.value;
      const courseItem = {
        idx: courseList[i]['idx'],
        sugangIdx: courseList[i]['sugangIdx'],
        courseName: courseList[i]['courseName'],
        isUse: courseList[i]['isUse'],
        courseType: courseList[i]['courseType'],
        code: courseList[i]['code'],
        roadMapType: courseList[i]['roadMapType'],
        roadMapUrl: courseList[i]['roadMapUrl'],
        roadMapName: courseList[i]['roadMapName'],
        codeConfirm: 'Y',
        isCompletion: courseList[i]['isCompletion'],
        completionText: courseList[i]['completionText'],
        courseDt,
      };

      initialValues.courseList.push(courseItem);
      push(courseItem);
    }
    //로드맵 이미지 이벤트 등록
    nextTick(() => {
      initialValues.courseList.forEach((_, index) => {
        roadImageUpload(index);
      });
    });
  }
};

const onSubmit = async () => {
  const { validate } = platfomrAddForm.value;
  const { valid, errors } = await validate();

  if (!valid) {
    alert('필수 값을 확인해주세요.');

    if (Object.keys(errors).length > 0) {
      nextTick(() => {
        document.getElementById(Object.keys(errors)[0]).scrollIntoView();
      });
    }
    return false;
  }

  if (initialValues.sugang.isCourseMenu === 'Y' && initialValues.menuList.filter(item => item.isUse === 'Y').length == 0) {
    alert('교육과정 안내 메뉴를 설정해주세요');
    return false;
  }

  if (initialValues.sugang.isPopup === 'Y') {
    if (popupList.value.length === 0) {
      alert('팝업을 1개 이상 등록해주세요.');
      return false;
    }

    for (let i = 0; i < popupList.value.length; i++) {
      const popup = popupList.value[i];

      if (!popup.popupImageUrl) {
        alert(`팝업 ${i + 1} 이미지를 등록해주세요.`);
        return false;
      }

      if (!popup.popupStartDate || !popup.popupEndDate) {
        alert(`팝업 ${i + 1} 노출기간을 선택해주세요.`);
        return false;
      }
    }
  }
  console.log('initialValues', initialValues);

  if (type.value === FORM_TYPE.INSERT) {
    insertSugang();
  } else if (type.value === FORM_TYPE.MODIFY) {
    modifySugang();
  }
};

const insertSugang = () => {
  btnLoading.value = true;
  sugangRegisterApi(buildSubmitData())
    .then(resp => {
      const { success } = resp.data;
      if (success) {
        alert('저장되었습니다.');
        back();
      } else {
        alert('저장에 실패하였습니다.');
      }
    })
    .catch(error => {
      if (error.response) {
        alert('서버에 에러가 발생하였습니다.');
        // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // 요청이 이루어 졌으나 응답을 받지 못했습니다.
        // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
        // Node.js의 http.ClientRequest 인스턴스입니다.
        console.log(error.request);
      } else {
        // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
        console.log('Error', error.message);
      }
      console.log(error.config);
    })
    .finally(() => {
      btnLoading.value = false;
    });
};

const modifySugang = () => {
  btnLoading.value = true;
  const { idx } = route.query;
  mainLoaiding.value = true;
  sugangModifyApi(idx, buildSubmitData())
    .then(resp => {
      const { success } = resp.data;
      if (success) {
        alert('저장되었습니다.');
        back();
      } else {
        alert('저장에 실패하였습니다.');
      }
    })
    .catch(error => {
      if (error.response) {
        alert('서버에 에러가 발생하였습니다.');
        // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // 요청이 이루어 졌으나 응답을 받지 못했습니다.
        // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
        // Node.js의 http.ClientRequest 인스턴스입니다.
        console.log(error.request);
      } else {
        // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
        console.log('Error', error.message);
      }
      console.log(error.config);
    })
    .finally(() => {
      btnLoading.value = false;
    });
};

const buildSubmitData = () => {
  const submitData = _.cloneDeep(initialValues);

  submitData.popupList =
    submitData.sugang.isPopup === 'Y'
      ? popupList.value.map((popup, index) => ({
          idx: popup.idx,
          sugangIdx: popup.sugangIdx,
          popupImageUrl: popup.popupImageUrl,
          popupLink: popup.popupLink,
          popupStartDate: popup.popupStartDate,
          popupEndDate: popup.popupEndDate,
          sort: index + 1,
        }))
      : [];

  delete submitData.sugang.popupImageUrl;
  delete submitData.sugang.popupImageName;
  delete submitData.sugang.popupLink;
  delete submitData.sugang.popupPeroid;
  delete submitData.sugang.popupStartDate;
  delete submitData.sugang.popupEndDate;

  return submitData;
};

const funcFormat = date => {
  let startDate = '';
  let endtDate = '';

  if (date[0]) {
    const startYear = date[0].getFullYear();
    const startMonth = date[0].getMonth() + 1 > 9 ? date[0].getMonth() + 1 : `0${date[0].getMonth() + 1}`;
    const startDay = date[0].getDate() > 9 ? date[0].getDate() : `0${date[0].getDate()}`;
    const startHour = date[0].getHours() > 9 ? date[0].getHours() : `0${date[0].getHours()}`;
    const startMinutes = date[0].getMinutes() > 9 ? date[0].getMinutes() : `0${date[0].getMinutes()}`;
    startDate = `${startYear}-${startMonth}-${startDay} ${startHour}:${startMinutes}`;
  }

  if (date[1]) {
    const endYear = date[1].getFullYear();
    const endtMonth = date[1].getMonth() + 1 > 9 ? date[1].getMonth() + 1 : `0${date[1].getMonth() + 1}`;
    const endtDay = date[1].getDate() > 9 ? date[1].getDate() : `0${date[1].getDate()}`;
    const endtHour = date[1].getHours() > 9 ? date[1].getHours() : `0${date[1].getHours()}`;
    const endtMinutes = date[1].getMinutes() > 9 ? date[1].getMinutes() : `0${date[1].getMinutes()}`;
    endtDate = `${endYear}-${endtMonth}-${endtDay} ${endtHour}:${endtMinutes}`;
  }

  return `${startDate} - ${endtDate}`;
};

const funcAddArray = () => {
  const { push } = courseListRef.value;

  const item = {
    code: '',
    codeConfirm: 'N',
    completionText: '',
    courseName: '',
    courseType: '',
    isCompletion: 'Y',
    isUse: 'N',
    roadMapType: 'x',
    roadMapUrl: '',
    roadMapName: '',
    courseStDt: '',
    courseEndDt: '',
    courseDt: '',
  };

  /* 2군데 추가 해야됨. */
  initialValues.courseList.push(item);
  push(item);

  nextTick(() => {
    document.getElementById(`courceForm${initialValues.courseList.length - 1}`).scrollIntoView();

    initialValues.courseList.forEach((_, index) => {
      roadImageUpload(index);
    });
  });
};

const funcRemoveArray = () => {
  const { remove } = courseListRef.value;

  if (initialValues.courseList.length === 1) {
    alert('최소 1개과정이 존재하여야 합니다.');
    return false;
  }
  if (confirm(`가장 마지막 과정이 삭제됩니다.\n삭제하시겠습니까?`)) {
    //마지막 index 삭제
    remove(initialValues.courseList.length - 1);
  }
};

const onCloseCompanyModal = () => {
  isCompanyModal.value = false;
};

const onCloseMenuModal = () => {
  isMenuModal.value = false;
};

const funcIsCompanyModal = () => {
  isCompanyModal.value = true;
};

const funcRowSelect = companyItem => {
  isCompanyModal.value = false;

  const { idx, kname } = companyItem;
  initialValues.sugang.companyIdx = idx;
  initialValues.sugang.companyName = kname;
  //강제 validate
  const { validate } = companyNameRef.value;
  validate();
};

const fileUpload = () => {
  const clientImage = document.getElementById('companyLogoUrl');
  //파일 change 이벤트
  clientImage.addEventListener('change', fileChange);
};

const fileChange = e1 => {
  const clientImage = document.getElementById('companyLogoUrl');
  const { validate } = companyLogoUrlRef.value;

  const { type } = e1.target.files[0];
  if (type.match(imgReg)) {
    const file = e1.target.files[0];

    const frm = new FormData();
    frm.append('file', file);

    fileUploadApi(frm)
      .then(async resp => {
        const { result } = resp.data;
        const { uploadUrl, fileName } = result;
        initialValues.sugang.companyLogoUrl = uploadUrl;
        initialValues.sugang.companyLogoName = fileName;

        await validate();
      })
      .catch(error => {
        if (error.response) {
          alert('서버에 에러가 발생하였습니다.');
          // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // 요청이 이루어 졌으나 응답을 받지 못했습니다.
          // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
          // Node.js의 http.ClientRequest 인스턴스입니다.
          console.log(error.request);
        } else {
          // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
          console.log('Error', error.message);
        }
        console.log(error.config);
      })
      .finally(() => {});
  } else {
    clientImage.value = '';
    alert('사진은 jpg,png만 가능합니다.');

    return false;
  }
};

const roadImageUpload = idx => {
  const ctmImage = document.getElementById(`ctmImage${idx}`);
  const { validate } = courseListRoadMapImgRef.value[idx];
  //파일 change 이벤트
  ctmImage.addEventListener('change', e2 => {
    const { type } = e2.target.files[0];

    if (type.match(imgReg)) {
      const file = e2.target.files[0];

      const frm = new FormData();
      frm.append('file', file);

      fileUploadApi(frm)
        .then(async resp => {
          const { result } = resp.data;
          const { uploadUrl, fileName } = result;
          initialValues.courseList[idx]['roadMapUrl'] = uploadUrl;
          initialValues.courseList[idx]['roadMapName'] = fileName;

          await validate();
        })
        .catch(error => {
          if (error.response) {
            alert('서버에 에러가 발생하였습니다.');
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {});
    } else {
      ctmImage.value = '';
      alert('사진은 jpg,png만 가능합니다.');

      return false;
    }
  });
};

const popImageFileChange = (e3, idx) => {
  const popupImage = document.getElementById(`popupImage${idx}`);
  const targetFile = e3.target.files[0];

  if (!targetFile) {
    return false;
  }

  const { type } = targetFile;

  if (type.match(imgReg)) {
    const frm = new FormData();
    frm.append('file', targetFile);

    fileUploadApi(frm)
      .then(resp => {
        const { result } = resp.data;
        const { uploadUrl, fileName } = result;

        popupList.value[idx].popupImageUrl = uploadUrl;
        popupList.value[idx].popupImageName = fileName;
      })
      .catch(error => {
        if (error.response) {
          alert('서버에 에러가 발생하였습니다.');
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
        console.log(error.config);
      })
      .finally(() => {});
  } else {
    alert('사진은 jpg,jpeg,png만 가능합니다.');

    if (popupImage) {
      popupImage.value = '';
    }

    return false;
  }
};

const checkCode = async value => {
  const { validate } = codeRef.value;
  if (value.length < 4) {
    alert('4자이상 입력해주세요');
    return false;
  }

  //코드체크 api
  codeCheckApi(value)
    .then(resp => {
      const { success, message } = resp.data;
      if (success) {
        alert(message);
        initialValues.sugang.dupConfirmCode = 'Y';
        validate();
      } else {
        alert(message);
        initialValues.sugang.dupConfirmCode = 'N';
      }
    })
    .catch(error => {
      if (error.response) {
        alert('서버에 에러가 발생하였습니다.');
        // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // 요청이 이루어 졌으나 응답을 받지 못했습니다.
        // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
        // Node.js의 http.ClientRequest 인스턴스입니다.
        console.log(error.request);
      } else {
        // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
        console.log('Error', error.message);
      }
      console.log(error.config);
    })
    .finally(() => {});
};

const preView = url => {
  window.open(url, '_blank');
};

const faqChange = faqArray => {
  initialValues.faqList.forEach(item => {
    const find = faqArray.find(faqItem => faqItem === item.faqCategoryIdx);

    if (find) {
      item['isUse'] = 'Y';
    } else {
      item['isUse'] = 'N';
    }
  });
};

const deleteImage = () => {
  initialValues.sugang.companyLogoUrl = '';
  initialValues.sugang.companyLogoName = '';
  const { validate } = companyLogoUrlRef.value;
  const clientImage = document.getElementById('companyLogoUrl');
  clientImage.value = '';
  validate();
};

const deleteRoadMapImage = idx => {
  const { validate } = roadMapRef.value[idx];
  initialValues.courseList[idx]['roadMapUrl'] = '';
  initialValues.courseList[idx]['roadMapName'] = '';

  const ctmImage = document.getElementById(`ctmImage${idx}`);

  if (ctmImage) {
    ctmImage.value = '';
  }
  validate();
};

const deletePopupImage = idx => {
  popupList.value[idx].popupImageUrl = '';
  popupList.value[idx].popupImageName = '';
  const popupImage = document.getElementById(`popupImage${idx}`);

  if (popupImage) {
    popupImage.value = '';
  }
};

const changePageCode = () => {
  initialValues.sugang.dupConfirmCode = 'N';
};

const getFaqList = async () => {
  await faqListApi()
    .then(resp => {
      const { success, data: respData } = resp.data;
      const { list } = respData;
      optionFaqList.length = 0;
      if (success) {
        for (let i = 0; i < list.length; i++) {
          optionFaqList.push({
            value: list[i].idx,
            text: list[i].categoryName,
          });
        }
      } else {
        optionFaqList.length = 0;
      }
    })
    .catch(error => {
      if (error.response) {
        // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // 요청이 이루어 졌으나 응답을 받지 못했습니다.
        // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
        // Node.js의 http.ClientRequest 인스턴스입니다.
        console.log(error.request);
      } else {
        // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
        console.log('Error', error.message);
      }
      console.log(error.config);
    })
    .finally(() => {});
};

const setFaq = () => {
  optionFaqList.forEach(faqItem => {
    initialValues.faqList.push({ faqCategoryIdx: faqItem.value, isUse: 'N' });
  });
};

const setNextChasuDate = modelData => {
  if (modelData) {
    if (modelData[0]) {
      initialValues.sugang.nextChasuStartDate = dateToString(modelData[0]);
    }

    if (modelData[1]) {
      initialValues.sugang.nextChasuEndDate = dateToString(modelData[1]);
    }
  }
};

const setChasuDate = modelData => {
  if (modelData) {
    if (modelData[0]) {
      initialValues.sugang.startDate = dateToString(modelData[0]);
    }

    if (modelData[1]) {
      initialValues.sugang.endDate = dateToString(modelData[1]);
    }
  }
};

const addPopupItem = () => {
  popupList.value.push(createPopupItem({ sort: popupList.value.length + 1 }));
  syncPopupSort();
};

const removePopupItem = idx => {
  popupList.value.splice(idx, 1);

  if (popupList.value.length === 0) {
    popupList.value.push(createPopupItem());
  }

  syncPopupSort();
};

const movePopupItem = (idx, step) => {
  const targetIndex = idx + step;

  if (targetIndex < 0 || targetIndex >= popupList.value.length) {
    return false;
  }

  const [popupItem] = popupList.value.splice(idx, 1);
  popupList.value.splice(targetIndex, 0, popupItem);
  syncPopupSort();
};

const setPopupDate = (idx, modelData) => {
  if (modelData) {
    if (modelData[0]) {
      popupList.value[idx].popupStartDate = dateToString(modelData[0]);
    }

    if (modelData[1]) {
      popupList.value[idx].popupEndDate = dateToString(modelData[1]);
    }
  }
};

const openMenuModal = () => {
  isMenuModal.value = true;
};

const onReturnData = async list => {
  initialValues.menuList = _.cloneDeep(list);
  isMenuModal.value = false;
  const { validate } = menuListRef.value;

  await validate();
};

const funcChangeMenuData = value => {
  let arr = '';
  if (value) {
    arr = _.cloneDeep(value)
      .filter(item => item.isUse === 'Y')
      .map(menuItem => menuItem.menuName)
      .join('|');
  }

  return arr;
};

const checkSugangCode = async (item, index) => {
  const { validate } = conectionRef.value[index];
  const { validate: courseDtValidate } = courseDtRef.value[index];

  const { code, courseType } = item;
  if (code.length < 1) {
    alert('코드를 입력해주세요');
    return false;
  }

  if (!courseType) {
    alert('연결 시킬 서비스를 선택해주세요.');
    return false;
  }
  if (courseType === 'ctm') {
    try {
      const { success, message, data } = await apiCtmSugangCode(code);
      if (success) {
        initialValues.courseList[index]['codeConfirm'] = 'Y';
        const { sugangStartDate, sugangEndDate } = data;
        initialValues.courseList[index]['courseDt'] = `${sugangStartDate}~${sugangEndDate}`;

        await courseDtValidate();
        const { errors, valid } = await validate();

        if (!valid) {
          alert(errors[0]);
          return false;
        }

        alert(message);
      } else {
        alert(message);
        initialValues.courseList[index]['courseDt'] = ``;
        initialValues.courseList[index]['codeConfirm'] = 'N';
      }
    } catch (error) {
      //initialValues.courseList[index]['codeConfirm'] = 'N';
      console.error('error : ', error);
    }
  } else if (courseType === 'itm') {
    //ITM
    try {
      const { success, data } = await apiItmSugangCode(code);
      if (success) {
        //alert('코드 확인이 되었습니다.');
        const { sugangStartDate, sugangEndDate } = data;
        initialValues.courseList[index]['courseDt'] = `${sugangStartDate}~${sugangEndDate}`;
        initialValues.courseList[index]['codeConfirm'] = 'Y';
        await courseDtValidate();
        const { errors, valid } = await validate();

        if (!valid) {
          alert(errors[0]);
          return false;
        }
        await validate();
      } else {
        alert('존재하지 않는 코드 입니다.');
        initialValues.courseList[index]['codeConfirm'] = 'N';
      }
    } catch (error) {
      initialValues.courseList[index]['codeConfirm'] = 'N';
      console.error('error : ', error);
    }
  }
};

const apiItmSugangCode = value => {
  return checkItmCode(value)
    .then(resp => {
      const { success, data } = resp.data;
      if (success) {
        return { success, data };
      } else {
        return false;
      }
    })
    .catch(error => {
      if (error.response) {
        alert('서버에 에러가 발생하였습니다.');
        // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // 요청이 이루어 졌으나 응답을 받지 못했습니다.
        // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
        // Node.js의 http.ClientRequest 인스턴스입니다.
        console.log(error.request);
      } else {
        // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
        console.log('Error', error.message);
      }
      console.log(error.config);
      return false;
    })
    .finally(() => {});
};

const apiCtmSugangCode = async value => {
  return await checkCtmSugangCode(value)
    .then(resp => {
      const { success, message, data } = resp.data;
      return { success, message, data };
    })
    .catch(error => {
      if (error.response) {
        alert('서버에 에러가 발생하였습니다.');
        // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // 요청이 이루어 졌으나 응답을 받지 못했습니다.
        // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
        // Node.js의 http.ClientRequest 인스턴스입니다.
        console.log(error.request);
      } else {
        // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
        console.log('Error', error.message);
      }
      console.log(error.config);

      return { success: false, message: error.message };
    })
    .finally(() => {});
};

const changeCodeValue = index => {
  initialValues.courseList[index]['codeConfirm'] = 'N';
};

const changeConectionSelect = (selectItem, idx) => {
  const { courseType } = selectItem;
  const { validate } = conectionRef.value[idx];

  if (courseType === '') {
    selectItem['codeConfirm'] = 'N';
    validate();
    return false;
  }
};

const changeRoadMapType = (selectItem, idx) => {
  //이미지 value 초기화
  const { roadMapType } = selectItem;
  const ctmImage = document.getElementById(`ctmImage${idx}`);

  if (ctmImage) {
    ctmImage.value = '';
  }
  selectItem['roadMapName'] = '';
  if (roadMapType === 'ctm') {
    selectItem['roadMapUrl'] = 'https://www.carrotenglish.kr/phone/program_english_map';
  } else {
    selectItem['roadMapUrl'] = '';
  }
};

const onChangeEditor = data => {
  const { contents, idx } = data;
  initialValues.courseList[idx].completionText = contents;
  const { validate } = completionListRef.value[idx];
  validate();
};

const back = () => {
  router.back();
};

const backConfirm = () => {
  if (confirm(`지금 돌아가시면 작성한 내용이 저장되지 않습니다.\n뒤로 돌아가시겠습니까?`)) {
    router.back();
  }
};

const onGuideCloseModal = () => {
  isGuideModal.value = false;
};

const resetTemplate = index => {
  const { setWysiwyg } = tinyeditorRef.value[index];
  setWysiwyg(completTemplete);
};

const initData = () => {
  const cur = new Date();
  const sevenDays = new Date(cur.getFullYear(), cur.getMonth(), cur.getDate() + 7);
  initialValues.sugang.chasuPeroid = [cur, sevenDays];

  siteUrl.value = userSite;

  setChasuDate(initialValues.sugang.chasuPeroid);
};
const Duplicate = selectValue => {
  isDuplicate.value = selectValue;
  if (selectValue === 'Y') {
    initialValues.sugang.distinctCnt = 1;
  } else if (selectValue === 'N') {
    initialValues.sugang.distinctCnt = 0;
  }
};
////////////////////////////////////////////////////// func //////////////////////////////////////////////////////

////////////////////////////////////////////////////// computed //////////////////////////////////////////////////////
const compConnectionList = computed(() => {
  const cloneConnectionList = _.cloneDeep(store.getters.getConnectionAdminList);
  cloneConnectionList.unshift({
    value: '',
    text: '-선택-',
  });
  return cloneConnectionList;
});
////////////////////////////////////////////////////// computed //////////////////////////////////////////////////////

////////////////////////////////////////////////////// watch //////////////////////////////////////////////////////
watch(
  () => courseListRef.value,
  cur => {
    if (cur) {
      if (type.value === FORM_TYPE.MODIFY) {
        setCourseList(courseArray.value);
      }
    }
  },
);

////////////////////////////////////////////////////// lifecycle //////////////////////////////////////////////////////
initData();
onMounted(() => {
  //수정일 경우
  if (Object.keys(route.query).length > 0) {
    const { idx } = route.query;
    mainLoaiding.value = true;
    type.value = FORM_TYPE.MODIFY;
    sugangDetailApi(idx)
      .then(resp => {
        const { success, data: respData } = resp.data;
        if (success) {
          setModifyInit(respData);
        }
      })
      .catch(error => {
        if (error.response) {
          alert('서버에 에러가 발생하였습니다.');
          // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // 요청이 이루어 졌으나 응답을 받지 못했습니다.
          // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
          // Node.js의 http.ClientRequest 인스턴스입니다.
          console.log(error.request);
        } else {
          // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
          console.log('Error', error.message);
          alert(error.message);
        }

        router.back();
        console.log(error.config);
      })
      .finally(() => {
        mainLoaiding.value = false;

        nextTick(() => {
          //고객사 로고 이벤트 등록
          fileUpload();
        });
      });
  } else {
    setInit();
  }
});

onBeforeMount(() => {
  conectionRef.value = [];
  roadMapRef.value = [];
  courseListImageRef.value = [];
  courseListRoadMapImgRef.value = [];
  completionListRef.value = [];
  tinyeditorRef.value = [];
  courseDtRef.value = [];
});
////////////////////////////////////////////////////// lifecycle //////////////////////////////////////////////////////

</script>

<style lang="scss">
#platformAddForm {
  scroll-behavior: smooth;
}
.no-wrap {
  white-space: nowrap;
}
.popup-guide-copy {
  color: #4661a9;
  font-size: 13px;
  font-weight: 600;
}
.popup-section-label {
  vertical-align: top;
  background-color: #eef4ff;
  border-top: 2px solid #9ebcff;
}
.popup-section-label-sub {
  background-color: #f7faff;
}
.popup-section-label-end {
  border-bottom: 2px solid #9ebcff;
}
.popup-section-body {
  background-color: #fcfdff;
  border-left: 4px solid #dbe6ff;
  border-right: 1px solid #dbe6ff;
}
.popup-section-body-start {
  border-top: 2px solid #9ebcff;
}
.popup-section-body-end {
  border-bottom: 2px solid #9ebcff;
}
.popup-section-badge {
  display: inline-block;
  min-width: 90px;
  padding: 8px 14px;
  border-radius: 999px;
  background-color: #2e63d4;
  color: #fff;
  font-weight: 700;
}
.popup-sort-copy {
  color: #294896;
  font-size: 13px;
  font-weight: 700;
}
</style>
